export const apiConstants = {
    LOGIN_USER: '/user/login',
    FORGOT_PASSWORD: '/user/forgetPassword',
    RESET_PASSWORD: '/user/resetPassword',
    GET_ROLES: '/role/getAllRoles',
    USERLIST: '/users',
    CREATE_CUSTOMER: '/owner/createCustomer',
    GET_CUSTOMER_LIST: '/owner/getCustomerList',
    CREATE_ASSESSMENT: '/assessment/createAssessment',
    GET_QUESTION_BANKS: '/owner/getQbank',
    INVITE_CANDIDATES: '/assessment/assessment/invite',
    BULK_INVITE_CANDIDATES:'/assessment/bulkInvite',
    GET_ALL_ASSESSMENTS: '/assessment/getAssessments',
    GET_ASSESSMENT_BY_ID: '/assessment/getAssessmentById',
    DELETE_ASSESSMENT: '/assessment/deleteAssessment',
    ASSESSMENT_SEARCH: '/assessment/assesmentSearch',
    GET_CANDIDATES: '/candidate/search',
    DELETE_CANDIDATE: '/candidate/delete',
    INVITE_ADMIN: '/organization/inviteAdmin',
    GET_All_TEAMS: '/organization/searchTeam',
    SIGNUP_CANDIDATE: '/assessment/signup/assessment/invite',
    LOGIN_CANDIDATE: '/candidate/login',
    DELETE_ADMIN: '/user/deleteAdmin',
    UPDATE_ASSESSMENT: '/assessment/assesment_status',
    GET_TEST_INFO: '/assessment/getTestinfo',
    START_TEST: '/assessment/starttest',
    TEST_SUBMIT: '/assessment/testEvaluation',
    GET_PROFILE: '/user/getUserProfile',
    GET_CANDIDATE_BY_ID: '/candidate/getCandidate',
    SEARCH_ALL_CANDIDATE: '/candidate/searchAllCandidates',
    IMAGE_UPLOAD: '/utils/uploadCustlogo',
    UPLOAD_PICTURE: '/utils/uploadPicture',
    CREATE_SITE_USER: '/owner/createCustomerfromsite',
    VERIFY_SITE_USER: '/owner/emailVerification',
    RUN_CODE: '/assessment/runCode',
    GET_NOTIFICATIONS: '/notification/getNotification',
    GET_ALL_NOTIFICATIONS: '/notification/getAllNotificationById',
    CLICK_TO_NOTIFICATION: '/notification/clickToNotification',
    READ_ALL_NOTIFICATION: '/notification/readAllNotification',
    CANDIDATE_TEST_LOGS: '/candidate/candidateTestLogs',
    UPDATE_ASSESSMENT_BY_ID: '/assessment/update',
    CANDIDATE_APPROVE: '/assessment/candidate/approve',
    CHANGE_PASSWORD: '/organization/changePassword',
    CLEAR_ALL_NOTIFICATIONS: '/notification/deleteAllNotifications',
    GET_SUPER_ADMIN_DASHBOARD: '/dashboard/getSuperAdminDashboard',
    BULK_DELETE_ASSESSMENT: '/assessment/bulkdelete',
    BULK_DELETE_CANDIDATE: '/candidate/bulkdelete',
    TEST_REPORT_OVERRIDE:'/candidate/reportOverride',
    UPLOAD_ANTICHEAT_SNAPSHOTS: '/assessment/uploadAntiCheatingSnapshots',
    UPLOAD_ANTICHEAT_AUDIO: '/assessment/uploadAntiCheatingAudio'
};

// V2= user
// v2 = role ( in the all roles apis)
//V2 = assessment (in all assessment api)   

 
// /organization/signup/assessment/invite        organization = assessment


